import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as CheckCircleIcon } from '../../assets/images/CheckedIcon.svg';

const features = [
    {
      "title": "Zero Operational Effort",
      "description": "Your only involvement is reviewing shared performance reports. We manage the farm end-to-end."
    },
    {
      "title": "100% Produce Ownership",
      "description": "You own what the land yields. We charge a fixed management fee, and the entire harvest value belongs to you."
    },
    {
      "title": "Transparent & Secure",
      "description": "Legally binding sub-lease agreements and a fixed cost structure ensure complete peace of mind."
    }
  ];

function InvestorInfo() {
    return (
      <Box>
        {features.map((feature, index) => (
          <Box key={index}  sx={{display:"flex", alignItems:"center", gap:"12px"}}>
          <Box >
            <CheckCircleIcon />
            </Box>
            <Box mt="14px">
              <Typography sx={{fontWeight:"500", fontSize:"14px", width:{xs:"90%",md:"95%"},}}>
               <span style={{fontWeight:"bold"}}>{feature.title}</span>  : {feature.description}
              </Typography>    
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

export default InvestorInfo;
